import React, { useState } from 'react'

export const useBloqueoPantalla = (variableCargaDefault = false) => {
    const [isLockedScreen,setIsLockedScreen] = useState(variableCargaDefault)

    const bloquearPantalla = () => setIsLockedScreen(true)
    const desbloquearPantalla = () => setIsLockedScreen(false)

    const ComponenteBloqueo = () => 
        <div
            className={`w-full h-screen top-0 left-0 fixed bg-black bg-opacity-60 items-center justify-center z-[1000000000] ${isLockedScreen ? "flex" : "hidden"}`}
        >
            <img
                className="bg-no-repeat bg-center w-20"
                src="https://www.doradoplaza.com/imagenes/cargando.gif"
            ></img>
        </div>
    
    return [bloquearPantalla,desbloquearPantalla,ComponenteBloqueo]
}
